<template>
<!-- kakaba select :) -->
	<select :disabled="disabled" :value="modelValue" v-on:input="onupdate()" @input="$emit('update:modelValue', parseInt($event.target.value) ? parseInt($event.target.value) : $event.target.value )"  class="form-select">
		<option value="" v-if="placeholder" disabled>{{ placeholder }}</option>
		<option :key="option.value" v-for=" option in options" :value="option.value">{{option.label}}</option>
		<template v-if="options.length === 0" >სია ცარიელია</template>
	</select>

</template>

<script>

export default {
	name: "KSelect",
	props: {
		options: {
			type: Array,
			default() {
				return []
			},
		},
		placeholder: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		modelValue: {
			required: true
		},
		onupdate:{
			type: Function,
			default: function (){}
		}
	},
}
</script>

<style scoped>

</style>